// deps
import React, { memo } from "react";

// styles
import {
    SavingsTextWrapper,
    CouponHeader,
    StyledText,
    TouchableOpacity,
    SavingsTextContainer,
    CouponIconContainer,
    StyledRemoveText,
    CouponAppliedWrapper,
} from "./styles";

// internal deps
import { default as TickIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/tick/20";
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";
import { PAYMENT_CART_HEADER } from "@swiggy-private/cart-test-ids";

//constants
import { Remove } from "@dineout-cart-ui/constants/index";

interface IAppliedCoupon {
    appliedCoupon?: string;
    subtitle?: string;
    title?: string;
    onClickRemoveCoupon: () => void;
}

const CouponAppliedContainer: React.FC<IAppliedCoupon> = (props: IAppliedCoupon) => {
    const { subtitle, title, onClickRemoveCoupon } = props;

    return (
        <CouponAppliedWrapper>
            <SavingsTextWrapper>
                <CouponHeader>
                    <StyledText
                        variant="V2.body1.neutral.bold"
                        color="text_High_Emphasis"
                        data-testid={PAYMENT_CART_HEADER.APPLIED_COUPON_CODE}
                    >
                        {title}
                    </StyledText>
                    <TouchableOpacity
                        data-testid={PAYMENT_CART_HEADER.DINEOUT_REMOVE_COUPON}
                        onClick={onClickRemoveCoupon}
                    >
                        <StyledRemoveText variant="V2.body2.neutral.medium" color="primary">
                            {Remove}
                        </StyledRemoveText>
                    </TouchableOpacity>
                </CouponHeader>

                {subtitle && (
                    <SavingsTextContainer>
                        <CouponIconContainer>
                            <GenericIcon
                                fillColor="text_High_Emphasis"
                                strokeColor="text_High_Emphasis"
                                Icon={TickIcon}
                            ></GenericIcon>
                        </CouponIconContainer>
                        <StyledText variant="V2.body2.neutral.regular" color="text_Med_Emphasis">
                            <div dangerouslySetInnerHTML={{ __html: subtitle }} />
                        </StyledText>
                    </SavingsTextContainer>
                )}
            </SavingsTextWrapper>
        </CouponAppliedWrapper>
    );
};
export default memo(CouponAppliedContainer);
